import { idToDate, dateDifferenceInDays } from '@trello/dates';
import { ProductFeatures } from '@trello/product-features';

export enum TrialSource {
  Moonshot = 'moonshot',
  UpgradePrompt = 'upgrade-prompt',
}

export interface Credit {
  id: string;
  count: number;
  type: string;
}

interface FreeTrialProperties {
  isActive: boolean;
  isExpired: boolean;
  days: number;
  daysLeft: number | null;
  startDate: Date;
  credit: Credit;
  trialSource: TrialSource;
}

export const getFreeTrialProperties = (
  credits: Credit[],
  products: number[],
): null | FreeTrialProperties => {
  const freeTrialCredit = credits.find((credit) => credit.type === 'freeTrial');

  if (!freeTrialCredit) {
    return null;
  }

  const startDate = idToDate(freeTrialCredit.id);
  const days = freeTrialCredit.count;
  const expiresAt = startDate.setDate(startDate.getDate() + days);
  const daysLeft = expiresAt
    ? Math.ceil(dateDifferenceInDays(new Date(), new Date(expiresAt), true))
    : null;
  const isActive =
    daysLeft !== null &&
    daysLeft > 0 &&
    ProductFeatures.isBusinessClassProduct(products[0]);
  return {
    isActive,
    isExpired: !!freeTrialCredit && !isActive,
    days,
    daysLeft,
    startDate,
    credit: freeTrialCredit,
    trialSource: days === 14 ? TrialSource.UpgradePrompt : TrialSource.Moonshot,
  };
};

export const hasFreeTrialCredit = (credits: Credit[] = []) => {
  return credits.some((credit) => credit.type === 'freeTrial');
};
